import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './Works.css'
import config from '../../config'
import {
  ContainerDivs,
  Link
} from '../'

@CSSModules(Styles)
export default class Works extends Component {
  static propTypes = {
  }
  constructor(props){
    super(props);
  }
  render() {
    const iconOne = require('../../../static/images/icons_step1.svg')
    const iconTwo = require('../../../static/images/icons_step2.svg')
    const iconThree = require('../../../static/images/icons_step3.svg')
    const iconFour = require('../../../static/images/icons_step4.svg')

    return <div styleName='works-wrap'>
      <ContainerDivs>
        <div styleName='works-title'>
          How to align your investments with your values
        </div>
        <div styleName='works-steps-photos'>
          <div styleName='works-steps'>
            <div styleName='works-step'>
              <div styleName='works-img-wrap'>
                <div styleName='works-step-title'>1</div>
                <img
                  styleName='works-step-img'
                  alt='Step one icon'
                  src={iconOne}
                />
              </div>
              <div styleName='works-step-info'>
                <Link to={config.routes.list} title='Search funds | Deforestation Free Funds'><span styleName='wht'>Search for mutual funds and ETFs</span></Link> by name, ticker, or asset manager. We have thousands of the most commonly held U.S. mutual funds in our database.
              </div>
            </div>
            <div styleName='works-step'>
              <div styleName='works-img-wrap'>
                <div styleName='works-step-title'>2</div>
                <img
                  styleName='works-step-img'
                  alt='Step two icon'
                  src={iconTwo}
                />
              </div>
              <div styleName='works-step-info'>
                See how much money your funds have invested in deforestation - whether in agricultural commodity producers and traders, the banks who finance them, or the brands who use those commodities in their products.
              </div>
            </div>
            <div styleName='works-step'>
              <div styleName='works-img-wrap'>
                <div styleName='works-step-title'>3</div>
                <img
                  styleName='works-step-img'
                  alt='Step three icon'
                  src={iconThree}
                />
              </div>
              <div styleName='works-step-info'>
                <Link to={config.routes.list} title='Search funds | Deforestation Free Funds'><span styleName='wht'>Look in our database</span></Link> for fund options with lower levels of investment in deforestation-risk companies.
              </div>
            </div>
            <div styleName='works-step'>
              <div styleName='works-img-wrap'>
                <div styleName='works-step-title'>4</div>
                <img
                  styleName='works-step-img'
                  alt='Step four icon'
                  src={iconFour}
                  />
              </div>
              <div styleName='works-step-info'>
                If you have a financial advisor or retirement plan manager, show them these results. Ask them to assist you in aligning your investments with your values. 
              </div>
            </div>
          </div>
        </div>
      </ContainerDivs>
    </div>
  }
}

